__turbopack_context__.v({
  "grid": "styles-module__WNKKWq__grid",
  "loadingWrapper": "styles-module__WNKKWq__loadingWrapper",
});
